module.exports = __webpack_public_path__ + "img/zi_4.f1f56919.png";